import { WayPay } from "./way-pay.interfaces";

//WAY TO PAY (Forma de pago)
export const wayPay = {
    '-1': '--',
    0: "--",
    1: "Contra entrega",
    2: "Con carta de garantía",
    3: "Fecha fija",
    4: "Diferido de la pesificación",
    5: "Diferido de la facturación",
    6: "Contra fijacion con mercaderia entregada",
    7: "Contra fijacion con carta Garantía"
}

export const wayPayNames = {
    contraEntrega: 1,
    conCartaGarantia: 2,
    fechaFija: 3,
    diferidoPesificacion: 4,
    diferidoFacturacion: 5,
    contraFixMercaderiaEntregada: 6,
    contraFixCartaGarantia: 7
}

export const pesosWithDischarge = [1, 2, 3, 5];
export const pesosWithOutDischarge = [1, 2, 3, 5];
export const pesosWithDeposit = [3];
export const pesosWithForward = [1, 2, 3, 5];

export const dolarsWithDischarge = [1, 2, 4];
export const dolarsWithOutDischarge = [1, 2, 4];
export const dolarsWithDeposit = [1, 4];
export const dolarsWithForward = [1, 2, 4];


export const WAY_PAY_VOID: WayPay = {
    wayPayName: -1,
    percentage: 0,
    expiration: '--',
    days: -1,
    isBusinessDays: 1,
    options: 0
}

export const WAY_PAY_TO_FIX_DEFAULT: WayPay = {
    wayPayName: wayPayNames.contraFixMercaderiaEntregada,
    percentage: 0,
    expiration: '--',
    days: 5,
    isBusinessDays: 1,
    options: 0
}

export const DEFAULT_WAY_PAY_WITH_COMMODITIES_HUGHES: WayPay = {
    ...WAY_PAY_VOID,
    wayPayName: wayPayNames.contraEntrega,
    days: 3,
    isBusinessDays: 1,
    percentage: 100
}

/**
 * Historical mapping: proforma payment code (CER050T5) -> CERCPA code that exchanges were sent with
 * before the structured exchange payment method. Not used at runtime; kept for the proforma table script.
 */
export const WAY_PAY_OV_IBM: Record<number, number> = {
    0: 0,

    //--- A precio ---\\
    2: 212, // 97.5% contra entrega
    18: 15, 
    44: 117,


    //--- A fijar ---\\
    19: 219, 
    17: 149,
    60: 99,
}